import { HttpErrorResponse, HttpInterceptorFn, HttpResponse } from '@angular/common/http'
import { of, throwError } from 'rxjs'
import { delay } from 'rxjs/operators'
import { ALL_TRANSACTIONS } from './transaction-details.mock'
import { AchDetailsApiResponse } from '../../../../../projects/ach-transaction-details/src/public-api'

const ERROR_SCENARIOS: Record<string, number> = {
    'error-401': 401,
    'error-404': 404,
    'error-500': 500,
    'error-502': 502,
}

const OK_DATA_SOURCES = {
    payments: { status: 'ok' as const },
    communications: { status: 'ok' as const },
    exports: { status: 'ok' as const },
}

export const mockApiInterceptor: HttpInterceptorFn = (req, next) => {
    if (!req.url.includes('/api/v1/ach-details/')) {
        return next(req)
    }

    const segments = req.url.split('/')
    const detailsIdx = segments.indexOf('ach-details')
    if (detailsIdx === -1 || detailsIdx + 1 >= segments.length) {
        return next(req)
    }
    const txnId = segments[detailsIdx + 1]
    const subResource = segments[detailsIdx + 2]

    if (req.method === 'POST' && subResource === 'exports') {
        return of(new HttpResponse({ status: 200, body: {} })).pipe(delay(200))
    }

    if (req.method === 'GET' && subResource === 'pdf') {
        return of(new HttpResponse({ status: 200, body: new Blob(['%PDF-1.4 mock'], { type: 'application/pdf' }) })).pipe(delay(200))
    }

    if (req.method === 'GET') {
        const errorStatus = txnId ? ERROR_SCENARIOS[txnId] : undefined
        if (errorStatus) {
            return throwError(() => new HttpErrorResponse({ status: errorStatus })).pipe(delay(300))
        }

        const txn = ALL_TRANSACTIONS.find((t) => t.transactionId === txnId)

        if (txn) {
            const envelope: AchDetailsApiResponse = {
                dataSources: OK_DATA_SOURCES,
                data: txn,
            }
            return of(new HttpResponse({ status: 200, body: envelope })).pipe(delay(500))
        } else {
            return throwError(() => new HttpErrorResponse({ status: 404, error: { message: 'Transaction not found' } })).pipe(delay(300))
        }
    }

    return next(req)
}
